module.exports = __webpack_public_path__ + "0115cd181c0cf00d84d90994e45e8650.png";